module.exports = __webpack_public_path__ + "img/home-two2.49d20c42.png";